import Vue from 'vue'
export default new Vue()
// export const Bus = new Vue();



// WEBPACK FOOTER //
// ./src/bus.js